"use client";
var brandBlueDark = "hsla(227, 100%, 50%, 1)";
var greyDark = "hsla(0, 0%, 44%, 1)";
var purpleLight = "hsla(263, 46%, 79%, 1)";
var purpleDark = "hsla(263, 51%, 33%, 1)";
var magentaLight = "hsla(311, 56%, 75%, 1)";
var magentaDark = "hsla(311, 94%, 26%, 1)";
var pinkLight = "hsla(341, 87%, 85%, 1)";
var pinkDark = "hsla(341, 55%, 48%, 1)";
var redLight = "hsla(0, 89%, 83%, 1)";
var redBase = "hsla(0, 89%, 57%, 1)";
var redDark = "hsla(0, 67%, 45%, 1)";
var orangeLight = "hsla(36, 100%, 80%, 1)";
var orangeDark = "hsla(36, 100%, 32%, 1)";
var yellowLight = "hsla(45, 100%, 80%, 1)";
var yellowDark = "hsla(45, 96%, 43%, 1)";
var greenLight = "hsla(123, 38%, 80%, 1)";
var greenDark = "hsla(122, 39%, 34%, 1)";
var aquaLight = "hsla(187, 73%, 77%, 1)";
var aquaDark = "hsla(187, 100%, 27%, 1)";
var blueLight = "hsla(207, 89%, 82%, 1)";
var black = "hsla(0, 0%, 0%, 1)";
var nubbinSize = "24px";

export { aquaDark, aquaLight, black, blueLight, brandBlueDark, greenDark, greenLight, greyDark, magentaDark, magentaLight, nubbinSize, orangeDark, orangeLight, pinkDark, pinkLight, purpleDark, purpleLight, redBase, redDark, redLight, yellowDark, yellowLight };
